import React from 'react';
import PropTypes from 'prop-types';

import './chartBarLeyend.scss';

const ChartBarLeyend = ({ seatTotal, province }) => {
  const absoluteMajority = parseInt(seatTotal / 2, 0) + 1;

  return (
    <div className="barLeyend">
      <dl className="barLeyend-list">
        <dt className="barLeyend-title">Escaños</dt>
        <dd className="barLeyend-definition">{seatTotal}</dd>

        {!province && (
          <>
            <dt className="barLeyend-title barLeyend-title--small">
              Mayoría absoluta
            </dt>

            <dd className="barLeyend-definition barLeyend-definition--small">
              {absoluteMajority}
            </dd>
          </>
        )}
      </dl>
    </div>
  );
};

ChartBarLeyend.propTypes = {
  seatTotal: PropTypes.number,
  province: PropTypes.string
};

ChartBarLeyend.defaultProps = {
  seatTotal: 0,
  province: null
};

export default ChartBarLeyend;
